<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page==='showing'"
    class="page"
  >
    <Header
      :setting="{
        title: '醫療團隊',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div
      v-for="division in
        spiderman.clinic[composable.member.info.clinic].divisions"
      :key="division"
      @click="toDetail(division)"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          {{ division }}
        </div>
      </div>
    </div>
  </div>

  <Detail
    v-else-if="page==='detail'"
    :divisions-have-schedule="divisionsHaveSchedule"
    :current-division="currentDivision"
    :doctors="doctorsInDivision"
    @cancel="page='showing'"
  />

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';
import Detail from './pages/Detail.vue';

export default {
  components: { Detail },
  setup() {
    const page = ref('initialization');
    const doctors = ref([]);
    const divisionsHaveSchedule = ref([]);
    const currentDivision = ref({});
    const doctorsInDivision = ref([]);

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        doctors.value = (await api.doctors.get(composable.member));
        const response = (await api.schedulePictures.get(composable.member));

        divisionsHaveSchedule.value = spiderman
          .generate.valuesArray({
            array: response,
            key: 'division',
          });

        page.value = 'showing';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    function toDetail(division) {
      currentDivision.value = division;

      doctorsInDivision.value = doctors.value.filter(
        (doctor) => doctor.division === division,
      );
      page.value = 'detail';
    }

    return {
      page,
      composable,
      spiderman,
      toDetail,
      divisionsHaveSchedule,
      currentDivision,
      doctorsInDivision,
    };
  },
};
</script>
